// MTLI office locations. Street addresses match what MTLI publishes online;
// Confirmed by Mitchell 2026-07-21.
export interface MtliOffice {
  key: "toronto" | "miami" | "vancouver" | "pensacola";
  name: string;
  nameFr: string;
  streetAddress?: string;
  city: string;
  region: string;
  postalCode?: string;
  country: string;
  phone: string;
  email: string;
  /** Which /locations/<slug> page this office anchors */
  locationSlug: string;
}

export const offices: MtliOffice[] = [
  {
    key: "toronto",
    name: "Canada Headquarters (Toronto)",
    nameFr: "Siège social Canada (Toronto)",
    streetAddress: "165 Gibson Dr",
    city: "Markham",
    region: "ON",
    postalCode: "L3R 3K7",
    country: "Canada",
    phone: "+1 (416) 293-2176",
    email: "sales@mtligroup.com",
    locationSlug: "ontario",
  },
  {
    key: "miami",
    name: "US Operations (Miami)",
    nameFr: "Opérations USA (Miami)",
    streetAddress: "2121 Biscayne Blvd",
    city: "Miami",
    region: "FL",
    postalCode: "33137",
    country: "United States",
    phone: "+1 (305) 433-7789",
    email: "sales@mtligroup.com",
    locationSlug: "florida",
  },
  {
    key: "pensacola",
    name: "US Southeast (Pensacola)",
    nameFr: "Sud-Est USA (Pensacola)",
    streetAddress: "6706 N 9th Ave",
    city: "Pensacola",
    region: "FL",
    postalCode: "32504",
    country: "United States",
    phone: "+1 (305) 433-7789",
    email: "sales@mtligroup.com",
    locationSlug: "florida",
  },
  {
    key: "vancouver",
    name: "Western Canada (Vancouver)",
    nameFr: "Ouest canadien (Vancouver)",
    streetAddress: "422 E 3rd St",
    city: "North Vancouver",
    region: "BC",
    postalCode: "V7L 0K1",
    country: "Canada",
    phone: "+1 (416) 293-2176",
    email: "sales@mtligroup.com",
    locationSlug: "british-columbia",
  },
];

export const officeBySlug = (slug: string | undefined) =>
  offices.find((o) => o.locationSlug === slug);

export const officeAddressLine = (o: MtliOffice) =>
  [o.streetAddress, `${o.city}, ${o.region}${o.postalCode ? " " + o.postalCode : ""}`, o.country]
    .filter(Boolean)
    .join(", ");
